module.exports = __webpack_public_path__ + "img/BANNER_VEH_PAG NUEVA - copia.4be3dbaa.png";